import { StrictRouteConfig } from "@/router/router";

export const reservationRoutes: StrictRouteConfig[] = [
    {
        path: "/customers/:customerId/offices/:officeId/reservations",
        name: "reservations",
        component: () => import(/* webpackChunkName: "reservation" */ "@/views/reservation/reservations.vue"),
        meta: {
            label: "Reservations",
            title: "Manage reservations",
            includeInSubNavigation: true,
            icon: "calendar-range-outline",
            requiresAuth: true,
            matchExact: true,
            path: ["dashboard", "reservations"],
            order: 20,
        },
    },
];
